import React, { Component } from 'react';
import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from 'reactstrap';
import classnames from 'classnames';
import DelegacaoLaminasComponent from './delegacao.laminas.component';
import DelegacaoConsultaComponent from './delegacao.consulta.component';
import IntlMessage from "../../../../helpers/intlMessage";
import DelegacaoConsultaComponentInlt from './delegacao-component-intl';
import DelegacaoLaminasComponentInlt from './delegacao-component-intl';

class DelegacaoComponent extends Component {
  constructor() {
    super();
    this.state = {
      activeTab: '1',
    };
  }

  render() {
    const { activeTab } = this.state;

    return (
      <Modal
        size='lg'
        isOpen={this.props.showModal}
        toggle={this.props.toggleModal}
      >
        <ModalHeader toggle={this.props.toggleModal}>
          <IntlMessage id = "dashboards.cytology.delegationBlades"/>
        </ModalHeader>
        <ModalBody>
          <div>
            <Nav tabs>
              <NavItem>
                <NavLink
                  className={classnames({ active: activeTab === '1' })}
                  onClick={() => {
                    this.toggle('1');
                  }}
                >
                  <IntlMessage id = "dashboards.cytology.delegationBlades"/>
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({ active: activeTab === '2' })}
                  onClick={() => {
                    this.toggle('2');
                  }}
                >
                  <IntlMessage id = "dashboards.cytology.consultCytotechnicians"/>
                </NavLink>
              </NavItem>
            </Nav>
            <br />
            <TabContent activeTab={activeTab}>
              <TabPane tabId='1'>
                <DelegacaoLaminasComponentInlt />
              </TabPane>
              <TabPane tabId='2'>
                <DelegacaoConsultaComponentInlt />
              </TabPane>
            </TabContent>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button onClick={this.props.toggleModal} color='danger'>
            <IntlMessage id = "dashboards.examDetails.cancel"/>
          </Button>
        </ModalFooter>
      </Modal>
    );
  }

  toggle = (activeTab) => this.setState({ activeTab });
}

export default DelegacaoComponent;



// WEBPACK FOOTER //
// ./src/pages/histologia/common/delegacao_laminas/delegacao.component.js